import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { mapDatesFromApiResponse } from '@oncolens/oncolens-ui/lib/utilities/dates';
// eslint-disable-next-line import/no-extraneous-dependencies
import { format } from 'date-fns';

// Magic function to give us a formatted date string when we don't have any time values
//
// Normally prototyping is frowned upon, but we want to be able to use DateOnly within .NET
// for dates that we know have no time component, and DateOnly can't parse any sort of time string within the request body
// eslint-disable-next-line no-extend-native, func-names
Date.prototype.toJSON = function () {
  if (this.getHours() + this.getMinutes() + this.getSeconds() === 0) {
    return format(this, 'yyyy-MM-dd');
  }
  return this.toISOString();
};

const client = clients.domain;

// For now, we're just adding an interceptor on a per-project basis, but we can do this for all clients within ui-lib in the future
client.interceptors.response.use((response) => {
  mapDatesFromApiResponse(response.data);

  return response;
});

export default client;
